import moment from 'moment';
import { get, set } from 'lodash';

export function formatDate(date) {
  return date ? moment(date).format('MMMM Do YYYY, h:mm:ss a') : 'Unknown';
}

export function getTableData(columns, rows, data) {
  return columns.slice(1).reduce(
    (acc, column) => acc.map((row) => set(row, column.accessor, get(get(data, column.accessor), row.name))),
    rows.filter((row) => !row.hidden).map((row) => ({ ...row }))
  );
}
